import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Box, Button, Center, CustomSpinner, Row, ScrollArea, Text } from '~/commonComponents';
import { useToggle } from '~/hooks';
import { Colors } from '~/themes/colors';
import { useOfficeTnCConsent } from '~/hooks/useOfficeTnCConsent';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

export const TermsAndConditions = () => {
  const { isAccepting, handleAccept, pdfUrl, isLoading } = useOfficeTnCConsent();
  const [isScrollBottom, scrollControls] = useToggle();
  const [numPages, setNumPages] = useState<number>(0);

  if (isLoading) {
    return (
      <div className="component_container">
        <div
          className="floating_container"
          style={{
            flexDirection: 'column',
            justifyContent: 'flex-start',
            marginInline: '20px',
          }}
        >
          <Center marginTop={40}>
            <CustomSpinner isLoading />
          </Center>
        </div>
      </div>
    );
  }

  if (!pdfUrl) {
    return (
      <div className="component_container">
        <div
          className="floating_container"
          style={{
            flexDirection: 'column',
            justifyContent: 'flex-start',
            marginInline: '20px',
          }}
        >
          <Center marginTop={40}>No Terms And Condition required this time</Center>
        </div>
      </div>
    );
  }

  return (
    <div className="component_container">
      <div
        className="floating_container"
        style={{
          flexDirection: 'column',
          justifyContent: 'flex-start',
          marginInline: '20px',
        }}
      >
        {!isLoading && (
          <Row
            backgroundColor={Colors.primary_50}
            paddingHorizontal={14}
            paddingVertical={10}
            border={`1px solid ${Colors.primary_500}`}
            marginTop={-10}
            marginLeft={-10}
            marginRight={-10}
          >
            <Text fontSize={16} color="primary_500">
              Before you continue, please read and accept our Terms and Conditions.
            </Text>
          </Row>
        )}
        <Box paddingBottom={10} paddingTop={10} flex={1} position="relative">
          <ScrollArea
            style={{ flex: 1, marginTop: 16, marginBottom: 16, maxHeight: 700, zIndex: 1 }}
            onEndReached={scrollControls.setOn}
          >
            <Center flex={1}>
              <Document
                loading={<CustomSpinner isLoading />}
                file={pdfUrl}
                onLoadSuccess={({ numPages: n }) => setNumPages(n)}
              >
                {Array.from({ length: numPages }, (_, i) => (
                  <div
                    key={i + 1}
                    style={{
                      overflow: 'hidden',
                      marginTop: i === 0 ? 0 : -40,
                    }}
                  >
                    <div style={{ margin: '-40px -20px' }}>
                      <Page pageNumber={i + 1} width={700} />
                    </div>
                  </div>
                ))}
                <Box height={100} />
              </Document>
            </Center>
          </ScrollArea>
          <Center
            paddingBottom={40}
            paddingTop={30}
            position="absolute"
            bottom={0}
            width="100%"
            zIndex={2}
            backgroundColor={Colors.white_alpha_85}
          >
            <Button
              text={isScrollBottom ? 'I Agree' : 'Scroll to Agree'}
              disabled={!isScrollBottom || isAccepting}
              isLoading={isAccepting}
              onClick={handleAccept}
            />
          </Center>
        </Box>
      </div>
    </div>
  );
};
